import { forwardRef, type Ref, type SVGProps } from "react";
const IconNotificationFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M12.55 26a4 4 0 0 0-.05.5 3.5 3.5 0 0 0 7 0 4 4 0 0 0-.05-.5z" />
    <path d="M24.36 12.54A8.53 8.53 0 0 0 17 4.07V3a1 1 0 0 0-2 0v1.06a8.29 8.29 0 0 0-7.37 8.19c0 8.23-4.64 6.47-4.64 11v.92A1.84 1.84 0 0 0 4.86 26h22.28A1.84 1.84 0 0 0 29 24.17v-.92c0-4.48-4.53-2.81-4.64-10.71" />
  </svg>
);
const ForwardRef = forwardRef(IconNotificationFilledSVG);
ForwardRef.displayName = "IconNotificationFilled";
export { ForwardRef as IconNotificationFilled };
